export default function groupDatesByDay(dates) {
  if (!Array.isArray(dates)) return {};

  const result = {};

  dates.forEach((d) => {
    if (!d) return;

    const trimmed = d.trim();
    const [datePart, timePart] = trimmed.split(" ");

    if (!datePart) return;

    if (!result[datePart]) {
      result[datePart] = [];
    }

    if (timePart) {
      result[datePart].push(timePart);
    }
  });

  return result;
}
